import React from 'react'

const OrderOverviewUI = ({ productType, orderFactor }) => {

    return (
        <>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        {(() => {
                            switch (productType) {
                                case 'Zebra_blinds':
                                case 'Roller_shades':
                                    return (
                                        <>
                                            <div className="col-lg-3 h6 pt-1 ">
                                                {productType}
                                            </div>
                                            <div className="col-lg-3 h6 pt-1">
                                                Total SQFT:
                                                &ensp;
                                                {orderFactor}
                                            </div>
                                            <div className="col-lg-3 h6 pt-1">
                                                Material: Fabrics, Rubes
                                            </div>
                                            <div className="col-lg-3 h6 pt-1">
                                                Efficient Cut
                                            </div>
                                        </>
                                    )
                                case 'Fauxwood':
                                    return (
                                        <>
                                            <div className="col-lg-3 h6 pt-1">
                                                <span className='text-success'>
                                                    {productType}
                                                </span>
                                            </div>
                                            <div className="col-lg-3 h6 pt-1">
                                                <span className='text-primary'>
                                                    Total Slat:
                                                </span>
                                                {/* &ensp;{counter} */}
                                            </div>
                                            <div className="col-lg-3 h6 pt-1">
                                                <span className='text-primary'>
                                                    Total Var:&ensp;
                                                </span>
                                                {orderFactor}
                                            </div>
                                            <div className="col-lg-3 h6 pt-1">
                                                <span className='text-primary'>
                                                    Materials:</span> White slats
                                            </div>
                                        </>
                                    )
                                case 'Materials':
                                    return (
                                        <>
                                            <div className="col-lg-3 h6 pt-1">
                                                {productType}
                                            </div>
                                            <div className="col-lg-3 h6 pt-1">
                                                Mention the  type of Material in product tag
                                            </div>
                                        </>
                                    )
                                default:
                                    return null
                            }
                        })()}
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderOverviewUI